import { Button, ComposedModal, ModalBody, ModalFooter, ModalHeader } from '@carbon/react'
import { FormConfig } from '../../lib/types'
import { useMemo } from 'react'


type Props = {
    open: boolean
    onClose: () => void
    data: Array<any>
    config: FormConfig
    onDiscard: () => void
    onEdit: () => void
    onSubmit: (overrideDuplicate: boolean) => void
}

function DuplicateRowsModal(props: Props) {
    const { open, onClose, data, config, onDiscard, onEdit, onSubmit } = props
    const keys = useMemo(() => data[0] ? Object.keys(data[0]) : [], [data])
    const headers = useMemo(() => config.elements.filter(element => keys.includes(element.field!))
        .map(element => element.label), [config, keys])

    function render(value: any) {
        if (typeof value === 'boolean')
            return <span className='text-blue-600 uppercase text-sm font-medium'>{String(value)}</span>
        return value
    }

    return (
        <ComposedModal open={open} onClose={onClose} >
            <ModalHeader label="Duplicate rows found">
                <h1>
                    We have found the similar row in our table
                </h1>
            </ModalHeader>
            <ModalBody>
                <table>
                    <thead>
                        <tr>
                            {headers.map((h, i) => (
                                <th key={i}>{h}</th>
                            ))}
                        </tr>
                    </thead>

                    <tbody>
                        {data.map((row, i) => {
                            return (
                                <tr className='cursor-default' key={i}>
                                    {Object.keys(row).map(item => <td key={item + i}>{render(row[item])}</td>)}
                                </tr>
                            )
                        })}
                    </tbody>
                </table>

            </ModalBody>
            <ModalFooter danger>
                <Button size='sm' kind='danger' onClick={onDiscard}>Discard</Button>
                <Button size='sm' kind='secondary' onClick={onEdit}>Edit</Button>
                <Button size='sm' kind='primary' onClick={() => onSubmit(true)}>Save</Button>
            </ModalFooter>
        </ComposedModal>
    )
}

export default DuplicateRowsModal